module.exports = __webpack_public_path__ + "img/globe.24925dfd.svg";